
import Profiles from '@/domains/UserCompany/User/Profiles/router';
import UserSettings from '@/domains/UserCompany/User/Settings/router';
import * as UserAccount from '@/store/modules/App/UserAccount/UserAccountModule';
import { store } from '@/main';
import cleanDuplicateRoutes from '@/utils/cleanDuplicateRoutes';
import Invoices from './Company/Admin/Invoices';
import Employees from './Company/Admin/Employees';
import CompanySettings from './Company/Admin/CompanySettings';

import CompanyAdminView from './Company/Admin';
import UserCompanyView from './UserCompanyView';

export const CompanyAdminBeforeEnter = (to, from, next) => {
  const getterName = `${UserAccount.FULL_NAMESPACE}/${UserAccount.GETTERS.GET_IS_COMPANY_ADMIN}`;
  const getterResult = store.getters[getterName];

  if (to.matched[1].name === 'CompanyAdmin') {
    next(getterResult || '/');
  }

  next();
};

const CompanyAdminRoutes = [
  {
    path: 'employees',
    name: 'Employees',
    component: () => Employees,
  },
  {
    path: 'invoices',
    name: 'Invoices',
    component: () => Invoices,
  },
  {
    path: 'settings',
    name: 'CompanySettings',
    component: () => CompanySettings,
  },
];

const CompanyAdminRouterModule = {
  path: 'company-admin',
  component: CompanyAdminView,
  beforeEnter: CompanyAdminBeforeEnter,
  children: CompanyAdminRoutes,
};

export const UserCompanyRoutes = [
  CompanyAdminRouterModule,
  ...Profiles,
  ...UserSettings,
];

export default [
  {
    path: '/',
    component: UserCompanyView,
    children: UserCompanyRoutes,
  },
];

export const getUserCompanyWithCompanyAdminOverride = (route) => {
  if (route.children) {
    /* eslint-disable no-param-reassign */
    route.children = cleanDuplicateRoutes(
      route.children,
      CompanyAdminRoutes,
    );
  }
  const newUserCompanyRoutes = UserCompanyRoutes.filter(item => item.path !== 'company-admin');
  return [...newUserCompanyRoutes, {
    ...CompanyAdminRouterModule,
    ...route,
  }];
};
